'use client'
import { HeroUIProvider } from "@heroui/react"
import { useRouter } from "@/locales/routing"
import { PropsWithChildren, useMemo } from "react"
import { useLocale } from "next-intl"
import { ToastProvider } from "@/provider/ToastProvider";
import { useMomentLocalization } from "@/hooks/useMomentLocalization"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { VersionChecker } from "@/components/VersionChecker"
import { ArmsRum } from "@/components/ArmsRum"
import { CookieConsent } from "@/components/CookieConsent"
import { patchDomForTranslation } from "@/vendor/patchDomForTranslation"

// 尽早执行：在 React 提交 DOM 前修补 insertBefore/removeChild，兼容浏览器翻译扩展
patchDomForTranslation()

const useHref = (href: string) => {
  const locale = useLocale()
  return useMemo(() => {
    return '/' + locale + (href.startsWith('/') ? href : '/' + href)
  }, [locale, href])
}


export default ({
  children
}: PropsWithChildren) => {

  const router = useRouter()
  useMomentLocalization()
  return (
    <NextThemesProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <HeroUIProvider navigate={router.push} useHref={useHref} className="h-full">
        <ToastProvider />
        <VersionChecker />
        <ArmsRum />
        <CookieConsent />
        {children}
      </HeroUIProvider>
    </NextThemesProvider>
  )
}